import { ChapterPage, ChapterQuery, Mission } from '@edwin-group/cj-graphql';
import { Chapter } from '@/types/types';
import { create } from 'zustand';
import { FindNextChapterUseCase } from '../../use-cases/find-next-chapter.use-case';

export enum AssessmentStatus {
  PRE_ASSESSMENT = 'PRE_ASSESSMENT',
  POST_ASSESSMENT = 'POST_ASSESSMENT',
}

interface ChapterState {
  chapter: Chapter | null;
  nextChapter: Chapter | null;
  status: AssessmentStatus | null;
  chapterPage: ChapterPage | null;
  showAssessment: boolean;
  showReflectionVideoSection: boolean;
  setChapter: (chapterResult: ChapterQuery, mission: Mission) => void;
}

export const useChapterStore = create<ChapterState>((set) => ({
  chapter: null,
  nextChapter: null,
  status: AssessmentStatus.PRE_ASSESSMENT,
  chapterPage: null,
  showAssessment: false,
  showReflectionVideoSection: false,
  setChapter: (chapterResult: ChapterQuery, mission: Mission) => {
    if (!chapterResult.missions || !chapterResult.missions.length) return;
    if (!chapterResult.missions[0]?.chapters || !chapterResult.missions[0]?.chapters.length) return;
    const chapter = chapterResult.missions[0]?.chapters[0] as Chapter;
    if (!chapter) return;
    const { next, isFirstChapter, isLastChapter } = FindNextChapterUseCase.execute(mission, chapter);
    set({
      nextChapter: next,
      chapter,
      status: isFirstChapter ? AssessmentStatus.PRE_ASSESSMENT : AssessmentStatus.POST_ASSESSMENT,
      showAssessment: (isFirstChapter || isLastChapter) && !!mission?.enableAssessment,
      showReflectionVideoSection: !!mission?.enableReflectionVideoSection,
      chapterPage: chapterResult.chapterPage as ChapterPage,
    });
  },
}));
